import { reduce } from 'lodash'

export default {
  hasSelected () {
    return reduce(this.schedules, (old, current) => {
      return old || current._selected
    }, false)
  }
}



// WEBPACK FOOTER //
// ./src/app/patient/agendas/schedulings/scheduled/index/resources/computed.js